import { PipsConfigState } from "state/tree/pipsConfig";

export const localPipsConfigSelector = {
  getIsPipDragging: (state: PipsConfigState) => state.isPipDragging,
  getPipsGridConfig: (state: PipsConfigState) => state.grid,
  getPipsLayout: (state: PipsConfigState) => state.grid.layout,
};
